import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ControlEmail} from '@kilobytelab/types';
import {Aviso} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiAvisosService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** avisos ***/

  getAvisosSinDescartar(): Promise<Aviso[]> {
    const url = `${this.apiUrl}avisos`;
    return firstValueFrom(this.http.get<Aviso[]>(url))
  }
  getAvisosAlumno(id: number): Promise<Aviso[]> {
    const url = `${this.apiUrl}avisos/${id}`;
    return firstValueFrom(this.http.get<Aviso[]>(url))
  }
  getAvisos(): Promise<Aviso[]> {
    const url = `${this.apiUrl}avisos/todos`;
    return firstValueFrom(this.http.get<Aviso[]>(url))
  }
  toggleAviso(id: number): Promise<any> {
    const url = `${this.apiUrl}avisos/toggle/${id}`;
    return firstValueFrom(this.http.get<any>(url))
  }
  descartarAviso(id: number): Promise<any> {
    const url = `${this.apiUrl}avisos/descartar/${id}`;
    return firstValueFrom(this.http.get<any>(url))
  }
  // getNotificacionesAlumnoFrom(id: number, fecha: string): Promise<Aviso[]> {
  //   const url = `${this.apiUrl}avisos/buscar/${id}/${fecha}`;
  //   return firstValueFrom(this.http.get<Aviso[]>(url))
  // }
  controlEmails(): Promise<ControlEmail[]> {
    const url = `${this.apiUrl}avisos/email/controles`;
    return firstValueFrom(this.http.get<ControlEmail[]>(url))
  }
  notificar(datos: {nombreCompleto: string, idAlumno: number, comentario: string}): Promise<number> {
    const url = `${this.apiUrl}avisos/mensaje/notificacion/alumno`;
    return firstValueFrom(this.http.post<number>(url, datos))
  }
  notificarAula(datos: {aula: number, comentario: string}): Promise<any> {
    const url = `${this.apiUrl}avisos/mensaje/notificacion/aula`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  notificarCentro(datos: {comentario: string}): Promise<any> {
    const url = `${this.apiUrl}avisos/mensaje/notificacion/centro`;
    return firstValueFrom(this.http.post<any>(url, datos))
  }
  updateControlesEmail(datos: {id: number, control: string}): Promise<void> {
    const url = `${this.apiUrl}avisos/email/controles/update/${datos.id}`;
    return firstValueFrom(this.http.post<void>(url, datos))
  }
  enviarEmail(data: {texto: string, asunto: string, pagos: boolean, control: string}): Promise<void> {
    const url = `${this.apiUrl}avisos/email`;
    return firstValueFrom(this.http.post<void>(url, data))
  }
  deleteAviso(id: number): Promise<any> {
    const url = `${this.apiUrl}avisos/${id}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
